export const MENU = [
  {
    title: 'Histórico de cursos realizados',
    url:
      'https://intranetpre.atresmedia.com/atresnet/oauth?redirect=historyTraining',
    urlProd:
      'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=historyTraining'
  },
  {
    title: 'Justificación de no asistencia',
    url:
      'https://intranetpre.atresmedia.com/atresnet/oauth?redirect=excuseAssist',
    urlProd:
      'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=excuseAssist'
  }
  // {
  // title: 'Catálogo de Formación',
  // url: 'https://intranetpre.atresmedia.com/atresnet/oauth?redirect=training',
  // urlProd:
  // 'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=training'
  // },
  // {
  // title: 'Catálogo de Formación de libre elección',
  // url:
  // 'https://intranetpre.atresmedia.com/atresnet/oauth?redirect=trainingFree',
  // urlProd:
  // 'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=trainingFree'
  // },
  // {
  // title: 'Búsqueda de Cursos',
  // url:
  // 'https://intranetpre.atresmedia.com/atresnet/oauth?redirect=trainingSearch',
  // urlProd:
  // 'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=trainingSearch'
  // },
  // {
  // title: 'Solicitud de Formación',
  // url:
  // 'https://intranetpre.atresmedia.com/atresnet/oauth?redirect=trainingApply',
  // urlProd:
  // 'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=trainingApply'
  // },
  // {
  // title: 'Consultar estado de la solicitud',
  // url:
  // 'https://intranetpre.atresmedia.com/atresnet/oauth?redirect=stateApply',
  // urlProd:
  // 'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=stateApply'
  // },
  // {
  // title: 'Solicitud de Reclamación',
  // url:
  // 'https://intranetpre.atresmedia.com/atresnet/oauth?redirect=applyReport',
  // urlProd:
  // 'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=applyReport'
  // },
  // {
  // title: 'Consultar estado de la reclamación',
  // url:
  // 'https://intranetpre.atresmedia.com/atresnet/oauth?redirect=stateReport',
  // urlProd:
  // 'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=stateReport'
  // },
  // {
  // title: 'Mi plan de Formación',
  // url:
  // 'https://intranetpre.atresmedia.com/atresnet/oauth?redirect=meTraining',
  // urlProd:
  // 'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=meTraining'
  // },
  // {
  // title: 'Consultar mi ficha de Formación',
  // url:
  // 'https://intranetpre.atresmedia.com/atresnet/oauth?redirect=fileTraining',
  // urlProd:
  // 'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=fileTraining'
  // },
];
